export default "__VITE_ASSET__DiNkA9iX__"